import { Button, Card, Flex, Input, message, Spin } from "antd"
import DeviderTitile from "../ui/DeviderProjects"
import DisplayType from "./DisplayType"
import { DisplayProjects, IProject } from "../types/project.type"
import { useEffect, useMemo, useState } from "react"
import Projects from "./Projects"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import { useActions } from "../../../hooks/useActions"
import ProjectModal from "../../../components/ProjectModal"

const ProjectsContainer = () => {
  const [displayType, setDisplayType] = useState<DisplayProjects>(DisplayProjects.TABLE)
  const [search, setSearch] = useState<string>("")
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const { getProjects } = useActions()
  const { projects, loading, error } = useTypedSelector((state) => state.projects)

  useEffect(() => {
    getProjects()
  }, [])

  useEffect(() => {
    if (error) {
      message.error(error)
    }
  }, [error])

  const searchedProjects = useMemo(() => {
    return projects.filter((project) => project.title.toLowerCase().includes(search.toLowerCase()))
  }, [projects, search])

  return (
    <Card>
      <Input placeholder="Search" value={search} onChange={(e) => setSearch(e.target.value)} />
      <DeviderTitile title="Projects" />
      <Flex vertical gap={16}>
        <Flex justify="space-between">
          <Button variant="solid" color="primary" onClick={() => setIsOpen(true)}>
            {" "}
            + Add Project
          </Button>
          <DisplayType displayType={displayType} setDisplayType={setDisplayType} />
        </Flex>
        {loading ? <Spin /> : <Projects projects={searchedProjects} displayType={displayType} />}
      </Flex>
      <ProjectModal isOpen={isOpen} setIsOpen={setIsOpen} refetch={getProjects} />
    </Card>
  )
}

export default ProjectsContainer
